import { useEffect, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AdminZone from './adminZone/AdminZone'
import LoginAdmin from './adminZone/LoginAdmin'
import ScortZone from './adminZone/ScortZone';

const LandingScortsAdmin = () => {

  const [userSession, setUserSession] = useState({
    nombre: "",
    apellido: "",
    usuario: "",
    role: "USUARIO_LOGIN"
  })

  useEffect(() => {
    const userSessionStorage = sessionStorage.getItem('userSessionStorage');
    if (!!userSessionStorage) {
      setUserSession(JSON.parse(userSessionStorage))
    }
  }, [])

  const validateRedirect = () => {
    switch (userSession.role) {
      case 'USUARIO_LOGIN':
        return (
          <LoginAdmin setUserSession={setUserSession} toast={toast} />
        )
      case 'USUARIO_ROOT':
        return (
          <AdminZone setUserSession={setUserSession} userSession={userSession} />
        )
      case 'USUARIO_ADMIN':
        return (
          <AdminZone setUserSession={setUserSession} userSession={userSession} />
        )
      case 'USUARIO_OPERACIONES':
        return (
          <AdminZone setUserSession={setUserSession} userSession={userSession} />
        )
      case 'USUARIO_SCORT':
        return (
          <ScortZone setUserSession={setUserSession} userSession={userSession} toast={toast} />
        )
      default:
        return (
          <></>
        )
    }
  }

  return (
    <>
      <ToastContainer autoClose={4000} hideProgressBar={true} />
      {
        validateRedirect()
      }
    </>
  )
}

export default LandingScortsAdmin
